import { GraduationCap, Shield, Users, Facebook } from "lucide-react";
import { Button } from "../../ui/button";
import OptimizedImage from "../../../utils/landing/OptimizedImage";
import { useSmoothNavigate } from "../../../utils/landing/useSmoothNavigate";

function TikTokIcon({ className }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M16.6 5.82c-.9-.98-1.4-2.26-1.4-3.62h-3.15v13.86c0 1.53-1.24 2.77-2.77 2.77a2.77 2.77 0 0 1-2.77-2.77 2.77 2.77 0 0 1 2.77-2.77c.29 0 .56.04.82.12v-3.19c-.27-.03-.54-.05-.82-.05-3.29 0-5.96 2.67-5.96 5.96s2.67 5.96 5.96 5.96 5.96-2.67 5.96-5.96V9.4a8.35 8.35 0 0 0 4.87 1.55V7.81c-1.28 0-2.44-.41-3.4-1.11a5.94 5.94 0 0 1-.11-.88z" />
    </svg>
  );
}

export function HeroSection() {
  const smoothNavigate = useSmoothNavigate();
  return (
    <section
      id="inicio"
      className="relative h-[700px] flex items-center justify-center overflow-hidden"
    >
      {/* Overlay de gradiente */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40 z-10" />

      {/* Video de fondo */}
      {/* <div className="absolute inset-0 z-0">
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="w-full h-full object-cover brightness-50"
                    preload="metadata"
                >
                    <source src="/videos/school-background.mp4" type="video/mp4" />
                    <OptimizedImage
                        src="/img/landing/banner2.jpg"
                        alt="Estudiantes en el colegio"
                        fill
                        className="object-cover brightness-50"
                        priority
                    />
                </video>
            </div> */}

      <div className="absolute inset-0 z-0">
        <OptimizedImage
          src="/img/landing/banner2.webp"
          alt="Estudiantes en el colegio"
          fill
          className="object-cover brightness-50"
          priority
        />
      </div>

      {/* Contenido principal */}
      <div className="container relative z-10 flex flex-col items-center text-center text-white space-y-8">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight">
          I.E.P. <span className="text-secondary-custom">SAN ISIDRO</span>
        </h1>
        <p className="text-xl md:text-2xl max-w-2xl text-white/90">
          Formando líderes para triunfar
        </p>

        {/* Botón de llamada a la acción */}
        <div className="mt-4">
          <Button
            className="web-btn-main"
            onClick={(e) => smoothNavigate(e, "#contacto")}
          >
            Solicita información
          </Button>
        </div>

        {/* Características destacadas */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12 w-full max-w-4xl">
          <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg flex items-center gap-3 hover:bg-white/20 transition-all duration-300">
            <div className="bg-secondary-custom p-2 rounded-full">
              <GraduationCap className="h-5 w-5 text-primary-custom" />
            </div>
            <div className="text-left">
              <h3 className="font-semibold">Excelencia Académica</h3>
              <p className="text-sm text-white/80">
                Programas educativos de calidad
              </p>
            </div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg flex items-center gap-3 hover:bg-white/20 transition-all duration-300">
            <div className="bg-secondary-custom p-2 rounded-full">
              <Shield className="h-5 w-5 text-primary-custom" />
            </div>
            <div className="text-left">
              <h3 className="font-semibold">Ambiente Seguro</h3>
              <p className="text-sm text-white/80">
                Espacios protegidos para el aprendizaje
              </p>
            </div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg flex items-center gap-3 hover:bg-white/20 transition-all duration-300">
            <div className="bg-secondary-custom p-2 rounded-full">
              <Users className="h-5 w-5 text-primary-custom" />
            </div>
            <div className="text-left">
              <h3 className="font-semibold">Docentes Calificados</h3>
              <p className="text-sm text-white/80">
                Profesionales con amplia experiencia
              </p>
            </div>
          </div>
        </div>

        {/* Redes sociales */}
        <div className="flex space-x-5 pt-2">
          <a
            href="https://www.facebook.com/IEPSanIsidro"
            target="_blank"
            rel="noreferrer"
            className="bg-secondary-custom p-3 rounded-full shadow-lg transition-all transform hover:scale-110 hover:brightness-110"
            aria-label="Facebook"
          >
            <Facebook className="h-7 w-7 text-primary-custom" />
          </a>
          <a
            href="https://www.tiktok.com/@i.e.p_sanisidro01?_r=1&_t=ZS-994fu1vN9NP"
            target="_blank"
            rel="noreferrer"
            className="bg-secondary-custom p-3 rounded-full shadow-lg transition-all transform hover:scale-110 hover:brightness-110"
            aria-label="TikTok"
          >
            <TikTokIcon className="h-7 w-7 text-primary-custom" />
          </a>
        </div>
      </div>

      {/* Gradiente inferior */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background to-transparent z-10" />
    </section>
  );
}
